import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { http } from "../auth";

import "../styles/login.css";
import { useThemeManager } from "../Hooks/ThemeManager";

/*-----Utils-----*/
import { getFullUrl } from "../utils/config.js";

/*-----Iconos-----*/
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { IoArrowBack } from "react-icons/io5";

const Recuperar = () => {
  const [step, setStep] = useState("request");
  const [showPassword, setShowPassword] = useState(false);
  const [baseURL, setBaseURL] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  const { themeColors } = useThemeManager();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const url = getFullUrl("image/logo_app_blanco");
    setLogoUrl(url);
  }, []);

   const fetchData = () => {
      http
        .get(`/config/intranet_config_residencial/metadatos`)
        .then((response) => {
          setBaseURL(response.data?.url);
        })
        .catch((error) => {
          console.error("Error en la solicitud:", error);
        });
    };
  
   useEffect(() => {
      fetchData();
    }, [])
  

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (token) {
      setStep("reset");
    }
  }, [location.search]);

  const sendRecovery = async (data) => {
    setLoading(true);
    try {
      await http.post(`${baseURL}api/auth/recover-password`, {
        email: data.email,
        access: "juridico",
      });
      toast.success("Se ha enviado un enlace de recuperación a su correo electrónico.");
      setStep("sent");
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Ha ocurrido un error al enviar la solicitud.");
      }
    } finally {
      setLoading(false);
    }
  };

  const resetPassword = async (data) => {
    setLoading(true);
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    try {
      await http.post(`${baseURL}api/auth/reset-password?token=${token}`, {
        password: data.password,
      });
      toast.success("Contraseña cambiada exitosamente.");
      setTimeout(() => navigate("/"), 3000);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Ha ocurrido un error al restablecer la contraseña.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (step === "sent") {
    return (
      <div className="containerBody">
        <div className="loginContainer loginIn">
          <div className="container">
            <Link to="/" className="back"><IoArrowBack /></Link>
            <div className="logoContainer">
              <img src={logoUrl} alt="Logo 360" />
            </div>
            <div className="info">
              <span className="titulo">Recuperar Contraseña</span>
            </div>
            <div className="formularioVeri">
              <span>Se ha enviado un enlace de recuperación a su correo electrónico.</span>
              <span>Revise su bandeja de entrada y siga las instrucciones.</span>
            </div>
            <Link to="/" className="buttonSubmit bg-primary" style={{ textDecoration: "none", textAlign: "center", marginTop: "25px" }}>
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="containerBody">
      <div className="loginContainer loginIn">
        <div className="container">
          <Link to="/" className="back"><IoArrowBack /></Link>
          <div className="logoContainer">
            <img src={logoUrl} alt="Logo 360" />
          </div>
          <div className="info">
            <span className="titulo">Recuperar Contraseña</span>
            {step === "request" ? (
              <span>
                ¿Ya posee una cuenta?{" "}
                <Link to="/" className="links">Iniciar Sesión</Link>
              </span>
            ) : (
              <span>Ingrese su nueva contraseña</span>
            )}
          </div>

          {step === "request" ? (
            <form className="formulario" onSubmit={handleSubmit(sendRecovery)}>
              <div className="formGroup">
                <input
                  className="formInput"
                  {...register("email", {
                    required: "¡Este campo es requerido!",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Ingrese un correo electrónico válido",
                    },
                  })}
                  placeholder=" "
                />
                <label className="formLabel">Correo electrónico</label>
                {errors.email && <p className="errors">{errors.email.message}</p>}
              </div>
              <button type="submit" className="buttonSubmit" style={{ background: themeColors?.primary ?? "#007bff" }} disabled={loading}>
                {loading ? (
                  <><div className="spinner"></div></>
                ) : (
                  <span>Enviar enlace</span>
                )}
              </button>
            </form>
          ) : (
            <form className="formulario" onSubmit={handleSubmit(resetPassword)}>
              <div className="formGroup">
                <input
                  className="formInput"
                  type={showPassword ? "text" : "password"}
                  {...register("password", {
                    required: "¡Este campo es requerido!",
                    minLength: { value: 8, message: "Mínimo 8 caracteres" },
                    maxLength: { value: 24, message: "Máximo 24 caracteres" },
                  })}
                  placeholder=" "
                />
                <label className="formLabel">Nueva contraseña</label>
                {errors.password && <p className="errors">{errors.password.message}</p>}
                <div onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEye className="iconEye" /> : <FaEyeSlash className="iconEye2" />}
                </div>
              </div>
              <div className="formGroup">
                <input
                  className="formInput"
                  type={showConfirm ? "text" : "password"}
                  {...register("confirmPassword", {
                    required: "¡Este campo es requerido!",
                    validate: (value) => value === watch("password") || "Las contraseñas no coinciden",
                  })}
                  placeholder=" "
                />
                <label className="formLabel">Confirmar contraseña</label>
                {errors.confirmPassword && <p className="errors">{errors.confirmPassword.message}</p>}
                <div onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? <FaEye className="iconEye" /> : <FaEyeSlash className="iconEye2" />}
                </div>
              </div>
              <button type="submit" className="buttonSubmit" style={{ background: themeColors?.primary ?? "#007bff" }} disabled={loading}>
                {loading ? (
                  <><div className="spinner"></div></>
                ) : (
                  <span>Restablecer contraseña</span>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default Recuperar;
